module.exports = __webpack_public_path__ + "media/packs/images/flags/BY-7e0496e8e766e17b418b5e48a2579b3c.png";